// src/config.js

const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL + "/api"
};

export default CONFIG;
